import { GlobalPropertiesSelect } from '@hortplus/properties-react';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { storesContext } from '../../../stores/storesContext';

const PropertySelect = () => {
  const userStore = useContext(storesContext);

  return (
    <Row className='mb-4 justify-content-center'>
      <Col
        xs={3}
        sm={2}
        className='d-flex align-items-center justify-content-end pr-0 font-weight-bold'
      >
        Property:
      </Col>
      <Col xs={9} md={8} lg={6}>
        <GlobalPropertiesSelect
          selectedDatabase={userStore.selectedDatabase}
          bearerToken={userStore.bearerToken}
          refreshBearerToken={userStore.refresh}
          propertiesStore={userStore.propertiesStore}
          useRpin
        />
      </Col>
      <Col
        xs={0}
        sm={1}
        className='d-flex align-items-center justify-content-end pl-0 font-weight-bold'
        style={{ visibility: 'hidden' }}
      >
        Property:
      </Col>
    </Row>
  );
};

export default observer(PropertySelect);

